<template>
  <div>
    <v-client-table
      :data='commandesCommissions'
      :columns="columns"
      :options="options"
      class="displayNoneVuePagination"
      ref="tableListeLigneCommandeCommissions">
      <div slot="dateDevisCommande" slot-scope="props"
           :class="{ 'textDecorationLineThrough':
              props.row.etat === sansSuite || props.row.etat === clos}">
        <span v-if="props.row.dateDevisCommande">
          {{props.row.dateDevisCommande | formatDate}}
        </span>
      </div>
      <div slot="fournisseur" slot-scope="props"
            :class="{ 'textDecorationLineThrough':
              props.row.etat === sansSuite || props.row.etat === clos}">
        {{  getFournisseur(props.row.id)}}
      </div>
      <div slot="commissionEtat" slot-scope="props">
        {{ $t(getEtatTraduction(props.row.commissionEtat)) }}
      </div>
      <div slot="prixUnitaire" slot-scope="props"
            :class="{ 'textDecorationLineThrough':
              props.row.etat === sansSuite || props.row.etat === clos}">
        {{  getLigneCommandeNormale(props.row)
          .map(l => l.prixUnitaire)
          .reduce((a, b) => a + b) | formatDevise}}
      </div>
      <div slot="quantite" slot-scope="props"
            :class="{ 'textDecorationLineThrough':
              props.row.etat === sansSuite || props.row.etat === clos}">
        {{  (getLigneCommandeNormale(props.row)[0].quantite * 100).toFixed(2) | formatPercent }}
      </div>
      <div slot="remise" slot-scope="props"
            :class="{ 'textDecorationLineThrough':
              props.row.etat === sansSuite || props.row.etat === clos}">
        {{  100 - Math.abs(getLigneCommandeNormale(props.row)[0].remise) | formatPercent}}
      </div>
      <div slot="pourcentageTva" slot-scope="props"
            :class="{ 'textDecorationLineThrough':
              props.row.etat === sansSuite || props.row.etat === clos}">
        {{ getLigneCommandeNormale(props.row)[0].tauxTva | formatPercent }}
      </div>
      <div slot="montantTva" slot-scope="props"
            :class="{ 'textDecorationLineThrough':
              props.row.etat === sansSuite || props.row.etat === clos}">
        {{ ((
                getLigneCommandeNormale(props.row)
                .map(l => l.totalHtAvecLigneRemise)
                .reduce((a, b) => a + b) *
                (1 + (getLigneCommandeNormale(props.row)[0].tauxTva / 100))
            ) - getLigneCommandeNormale(props.row)
                .map(l => l.totalHtAvecLigneRemise)
                .reduce((a, b) => a + b)).toFixed(2)
        }} €
      </div>
      <div slot="totalHt" slot-scope="props"
            :class="{ 'textDecorationLineThrough':
              props.row.etat === sansSuite || props.row.etat === clos}">
        {{ getLigneCommandeNormale(props.row)
          .map(l => l.totalHtAvecLigneRemise)
          .reduce((a, b) => a + b) | formatDevise}}
      </div>
      <div slot="typeReferenceExterne" slot-scope="props" :class="{ 'textDecorationLineThrough':
              props.row.etat === sansSuite || props.row.etat === clos }">
        {{ props.row.typeReferenceExterne === caGaranti
        ? $t('listeCommandeCommissions.table.caGaranti')
        : $t('listeCommandeCommissions.table.reversementGaranti')}}
      </div>
    </v-client-table>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { NORMAL, REGROUPEMENT } from '@/configuration/devisConf';
import { columnsSplice } from '@/services/general/columns';
import * as devisConf from '@/configuration/devisConf';
import { ALL_ETAT_COMMISSION, TYPE_REFERENCE_EXTERNE_CA_GARANTI } from '@/configuration/dcf/dcfConf';

export default {
  name: 'recapitulatifCommissionsGaranties',
  props: {
    commandesCommissions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sansSuite: devisConf.ETAT_SANSSUITE,
      clos: devisConf.ETAT_CLOTURER,
      caGaranti: TYPE_REFERENCE_EXTERNE_CA_GARANTI,
    };
  },
  computed: {
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateDevisCommande: this.$i18n.t('listeFactureCommissions.table.dateDevisCommande'),
          fournisseur: this.$i18n.t('listeCommandeCommissions.commandeGarantie.fournisseur'),
          commissionEtat: this.$i18n.t('listeFactureCommissions.table.referenceEtat'),
          prixUnitaire: this.$i18n.t('listeCommandeCommissions.ligneCommande.prixUnitaire'),
          quantite: this.$i18n.t('listeCommandeCommissions.ligneCommande.quantite'),
          remise: this.$i18n.t('listeCommandeCommissions.ligneCommande.remise'),
          totalHt: this.$i18n.t('listeCommandeCommissions.ligneCommande.totalHt'),
          pourcentageTva: this.$i18n.t('listeCommandeCommissions.ligneCommande.pourcentageTva'),
          montantTva: this.$i18n.t('listeCommandeCommissions.ligneCommande.montantTva'),
          typeReferenceExterne: this.$i18n.t('listeFactureCommissions.table.typeReferenceExterne'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          delete: 'colonneSelected',
        },
        sortable: ['libelle', 'prixUnitaire', 'remise', 'totalHt'],
      };
    },
    columns() {
      const columns = ['dateDevisCommande', 'fournisseur', 'commissionEtat', 'quantite', 'prixUnitaire', 'totalHt', 'pourcentageTva', 'montantTva', 'remise', 'typeReferenceExterne'];
      if (!this.visualisationTva) {
        columnsSplice(columns, 'pourcentageTva');
        columnsSplice(columns, 'montantTva');
      }
      return columns;
    },
  },
  methods: {
    getFournisseur(id) {
      return this.commandesCommissions.find(c => c.id === id)
        .intervenants[0].nomCommercial;
    },
    getLigneCommandeRegroupement(commande) {
      return commande.lignesCommande.filter(l => l.type === REGROUPEMENT);
    },
    getLigneCommandeNormale(commande) {
      return commande.lignesCommande.filter(l => l.type === NORMAL);
    },
    getEtatTraduction(value) {
      return ALL_ETAT_COMMISSION.find(e => e.value === value)?.libelle ?? '';
    },
  },
};
</script>

<style scoped>

</style>
